






import Vue from 'vue'
import { STORE_MODULES } from '@/enums'
import { createNamespacedHelpers } from 'vuex'
import { IParcel } from '../../../../models'
import { IStateOrder } from '@/models'

declare const easyPack: any

const { mapState } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'ParcelWidget',

    model: {
        prop: 'parcel',
        event: 'update:parcel',
    },

    props: {
        parcel: Object as () => IParcel,
    },

    computed: {
        ...(mapState(['shippingAddress']) as MapStateToComputed<IStateOrder>),

        parcelInternal: {
            get(): IParcel | undefined {
                return this.parcel
            },
            set(parcel: IParcel) {
                this.$emit('update:parcel', parcel)
            },
        },
    },

    mounted() {
        easyPack.init({
            defaultLocale: 'pl',
            points: {
                types: ['parcel_locker'],
            },
            map: {
                initialTypes: ['parcel_locker'],
                useGeolocation: false,
            },
        })

        const map = easyPack.mapWidget('parcel-widget', (point: any) => {
            this.parcelInternal = {
                name: point.name,
                addressFormatted: `${point.address.line1}, ${point.address.line2}`,
            }
        })

        map.searchPlace(this.shippingAddress?.cityName ?? '')
    },

    beforeDestroy() {
        // @ts-ignore
        window.mapReady = false
        // @ts-ignore
        window.mapRendered = false
    },
})
